import { onAddSolicitudFirma, onAddSolicitudesFirma, onResetStateSolicitudFirma } from "store/solicitudFirma/solicitudFirmaSlice";
import { useAppDispatch, useAppSelector } from "./reduxHooks"
import { setIsLoading, setMessageLoading } from "store";
import { getFiles } from "services/demandasServices/demandasService";
import { useVisorDocumentosStore } from "./useVisorDocumentosStore";
import { onShowModalVisor } from "store/demandas/demandasSlice";
import { SolicitudesFirma } from "interfaces/solicitudFirma/solicitudFirmaInterface";

export const useSolicitudesFirmaStore = () =>{
    const dispatch = useAppDispatch();
    const { solicitudFirma , solicitudesFirma   } = useAppSelector((state)=>state.solicitudFirma);
    const { openVisorDocumentos, addDocumentPDF } = useVisorDocumentosStore();

    const startGetFile = (params: { path: string }) => {
        dispatch(setIsLoading(true));
        dispatch(setMessageLoading("Cargando Archivo"));
        getFiles(params)
          .then(({ data }) => {
            const fileUrl = window.URL.createObjectURL(
              new Blob([data], { type: "application/pdf" })
            );
            addDocumentPDF([fileUrl]);
            dispatch(setIsLoading(false));
            setTimeout(() => {
              dispatch(setMessageLoading(""));
            }, 500);
            openVisorDocumentos(true);
          })
          .catch((err) => {
            console.log(err);
            dispatch(setIsLoading(false));
            dispatch(setMessageLoading(""));
          });
      };

      const openModalVisor = (status: boolean) =>
      dispatch(onShowModalVisor(status));
    const addDataSolicitudFirma = (data:any) =>dispatch(onAddSolicitudFirma(data));
    const resetStateSolicitudFirma = () =>dispatch(onResetStateSolicitudFirma());
    const addSolicitudesFirma = (data:SolicitudesFirma[]) => dispatch(onAddSolicitudesFirma(data))

    return{
        /**properties */
        solicitudFirma,
        solicitudesFirma,
        /**methods */
        startGetFile,
        openModalVisor,
        addDataSolicitudFirma,
        resetStateSolicitudFirma,
        addSolicitudesFirma,
    }
}